import { useEffect, useState } from 'react'

interface Hl7Codes {
  [version: string]: string[]
}

export function useHl7Codes() {
  const [data, setData] = useState<Hl7Codes | undefined>(undefined)
  const [error, setError] = useState<Error | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchCodes() {
      try {
        const response = await fetch('/hl7-codes.json')
        if (!response.ok) {
          throw new Error('Failed to fetch HL7 codes')
        }
        const json = await response.json()
        setData(json.hl7)
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)))
      } finally {
        setLoading(false)
      }
    }

    fetchCodes()
  }, [])

  return { data, error, loading }
}
